import React from 'react';
import useRef from '@/util/hook/useRef';
import { BUTTON_SIZE, BUTTON_TYPE } from '@/config/ui/button';
import { S } from '../style';
export const BackButton = ({ children, onButtonClick, isAvailable, isV2, isLoading, spinner, size = BUTTON_SIZE.AUTO, type = BUTTON_TYPE.BUTTON, href, }) => {
    const btnRef = useRef(null);
    // #NOTES
    // To avoid duplicate actions (e.g., API calls), we disable the button upon clicking and
    // enable it once `onButtonClick()` is complete.
    const onClickHandler = async () => {
        if (btnRef.current)
            btnRef.current.disabled = true;
        await onButtonClick();
        if (btnRef.current)
            btnRef.current.disabled = false;
    };
    return type === BUTTON_TYPE.BUTTON ? (<S.BackButton ref={btnRef} disabled={!isAvailable} isV2={isV2} onClick={onClickHandler} size={size}>
      {isLoading ? <S.Loading>{spinner || '...'}</S.Loading> : children}
    </S.BackButton>) : (<S.BackButtonLink isV2={isV2} href={href} size={size}>
      {children}
    </S.BackButtonLink>);
};
